var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center mb-2"},[_c('button',{on:{"click":_vm.toggleAlert}},[_c('app-icon',{staticClass:"h-5 w-5 mr-2",class:_vm.value ? 'text-purple' : 'text-gray-400',attrs:{"name":_vm.value ? 'alarm-bell-stroke' : 'alarm-bell-off-stroke'}})],1),_vm._v(" "),_c('div',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }